<template>
  <div>
    <div v-if="is3dLoaded && !isDataPresent">
      <EmptyState icon="mdm"/>
      {{$t('INDENT_NO_VISUALISATION')}}
    </div>
    <div id='3d-section'>
      <div id='tip-3d' style='visibility: hidden; position: absolute;'> </div>
      <div id='filter'>
      <RangeSlider id='input-num' v-model = "num" type="number"
          :max="stackLength"
          :min="0"
          size="small"
          input-size = "medium"
          @change="handleChange"
          show-input>
      </RangeSlider>
          <div>
      <Select v-model="curSelectCons"
            @change="selectConsignee"
            placeholder="All Consignees"
            popper-class="dropdowntag">
                <Option
                  v-for="item in consigneeIds"
                  :key="item"
                  :label="item"
                  :value="item">
                </Option>
        </Select>
                  &nbsp;&nbsp;&nbsp;&nbsp;
          Show Truck: <SwitchBtn v-model="showTruck"
                     @change="changeTruckState()"
                     active-text="Yes" inactive-text="No"
                     active-color="#404040" inactive-color="#D9E2E7" /> &nbsp;&nbsp;&nbsp;&nbsp;

              <Button type="primary" @click="revisualize()">Re-Visualize</Button>
          </div>
    </div>
      <!-- DONT CHANGE THE ID: BASED ON THIS CANVAS GET GENERATED -->
      <div id='pando-3d'></div>
      <p>Vehicle 3D Model by <a href="https://sketchfab.com/danieljorge435">danieljorge435</a> is licensed under <a href = "https://creativecommons.org/licenses/by/4.0/">CC BY-4.0.</a></p>
      <div v-if='canShowVisualization'> </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { pando3D, TRUCK, LEVEL } from '@/components/common/3d-visualization/index';
import EmptyState from '@/components/common/EmptyState';
import Row from '../../freight/MaterialFreight/Row';

export default {
  components: {
    Row,
    EmptyState,
  },

  data() {
    return {
      is3dLoaded: false,
      isDataPresent: false,
      num: 1,
      curSelectCons: '',
      stackLength: 0,
      consigneeIds: [],
      showTruck: true,
      visualizationData: null,
      isLoading: false,
    };
  },

  props: ['isShowing', 'orderDetails'],

  async created() {
    // if (this.canShowVisualization) {
    //   await this.loadTruck();
    // }
  },
  computed: {
    canShowVisualization() {
      if (this.isShowing && this.is3dLoaded === false) {
        this.loadTruck();
        return true;
      }
      return false;
    },
  },
  methods: {
    handleChange(value) {
      LEVEL.LEVEL.showUntil(value);
    },
    selectConsignee(value) {
      LEVEL.LEVEL.showConsignee(value);
      if (value !== 'All Consignees') {
        const consigneeStack = (this.visualizationData && this.visualizationData.stacks &&
          this.visualizationData.stacks.filter(mat => mat.ref_id === value)) || [];
        this.stackLength = consigneeStack.length;
      } else {
        this.stackLength = (this.visualizationData.stacks && this.visualizationData.stacks.length) || 0;
      }
      this.num = this.stackLength;
    },
    async loadTruck(revisualize = false) {
      this.isloading = true;
      const payload = {
        indentId: this.orderDetails.order_number,
        revisualize,
      };
      const result = await this.$store.dispatch('order/get3dVisualization', payload);
      if (!result.error && result.data) {
        this.is3dLoaded = true;
        this.isDataPresent = true;
        this.visualizationData = result.data.packing_output_file || {};
        const output = (result.data.packing_output_file && result.data.packing_output_file.stacks) || [];
        this.stackLength = output.length;
        this.consigneeIds = output.map(stack => stack.ref_id);
        this.consigneeIds = ['All Consignees', ...new Set(this.consigneeIds)];
        this.num = this.stackLength;
        this.visualizationData.showTruck = this.showTruck;
        if (revisualize) {
          location.reload();
        } else {
          TRUCK.TRUCK.draw3D(this.visualizationData);
        }
      } else {
        this.is3dLoaded = true;
        this.isDataPresent = false;
      }
      this.isloading = false;
    },
    changeTruckState() {
      pando3D.pando3D.changeTruckState(this.showTruck);
    },
    async revisualize() {
      await this.loadTruck(true);
      this.changeTruckState();
    },
  },
};
</script>
<style lang="scss">
  #tip-3d {
    visibility: hidden;
    position: absolute;
    color: white;
    font-family:sans-serif;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    background-color: red;
  }
</style>
